import { AnalyticsInfoIcon, Heading } from '@weave/design-system';
import { InfoCard } from '../InfoCard/InfoCard';
import { childStyles } from './styles';

type InsurancePayerMixWebCoverageProps = {
  currentWebCoveragePercentage: number;
};

export const InsurancePayerMixWebCoverage = ({
  currentWebCoveragePercentage,
}: InsurancePayerMixWebCoverageProps) => {
  return (
    <InfoCard title="Current Web Coverage">
      <div css={childStyles}>
        <AnalyticsInfoIcon size={30} />
        <Heading level={2} css={{ margin: 0 }}>
          {currentWebCoveragePercentage ? `${currentWebCoveragePercentage}%` : '-'}
        </Heading>
      </div>
    </InfoCard>
  );
};
